import React from 'react'
import { Button } from 'antd';
import "./CustomButton.scss";


export const CustomButton = ({ children, customBtnClass, onClick, disabled}) => {
  return (
    <Button className={`${customBtnClass}`} onClick={onClick} disabled={disabled} >{children}</Button>
  );
}